import React, { useState } from "react"
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Tabs,
  Tab,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material"
import { Menu as MenuIcon } from "@mui/icons-material"
import { Link } from "react-router-dom"
import styled from "styled-components"
import YummyPiLogo from "../images/yummyPiLogo.png"
import { useTheme } from "@mui/material/styles"

const Header = () => {
  const [value, setValue] = useState(0) // State to manage the active tab
  const [anchorEl, setAnchorEl] = useState(null) // State to handle the dropdown menu
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")) // Check if the screen is small

  const handleChange = (event, newValue) => {
    setValue(newValue) // Update the active tab index
  }

  // Function to reset tab value when clicking the logo
  const handleLogoClick = () => {
    setValue(0)
  }

  // Function to handle opening of the mobile menu
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  // Function to handle closing of the mobile menu
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  return (
    <AppBar position="static" style={{ backgroundColor: "#5c1e47" }}>
      <Container>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <StyledLink to="/" onClick={handleLogoClick}>
              <Logo src={YummyPiLogo} alt="YummyPi Logo" />
              YummyPi Recipes ❤
            </StyledLink>
          </Typography>

          {isMobile ? (
            // Show the dropdown menu on small screens
            <>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={handleMenuOpen}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={handleMenuClose} component={TabLink} to="/">
                  Home
                </MenuItem>
                <MenuItem
                  onClick={handleMenuClose}
                  component={TabLink}
                  to="/search"
                >
                  Search
                </MenuItem>
                {/* Uncomment to add the Create tab */}
                {/* <MenuItem
                  onClick={handleMenuClose}
                  component={TabLink}
                  to="/create"
                >
                  Create
                </MenuItem> */}
                <MenuItem
                  onClick={handleMenuClose}
                  component={TabLink}
                  to="/contact"
                >
                  Contact
                </MenuItem>
              </Menu>
            </>
          ) : (
            // Show regular tabs on larger screens
            <Tabs value={value} onChange={handleChange} textColor="inherit">
              <Tab label="Home" component={TabLink} to="/" />
              <Tab label="Search" component={TabLink} to="/search" />
              {/* Uncomment to add the Create tab */}
              {/* <Tab label="Create" component={TabLink} to="/create" /> */}
              <Tab label="Contact" component={TabLink} to="/contact" />
            </Tabs>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  )
}

// Styled Link component to keep the style and spacing
const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  font-family: "Pacifico", cursive;
  display: flex;
  align-items: center;
  padding: 10px;
`

const TabLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`

const Logo = styled.img`
  width: 40px;
  height: 40px;
  margin-right: 8px;
`

export default Header
